// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1ky6w","actions":"GroupTable_actions__2fyHb","deleteModalFooter":"GroupTable_deleteModalFooter__3sDMK"};